/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * States for video provider configuration lifecycle.
 * Tracks the status of fetching and configuring video provider settings.
 */
export enum VideoProviderState {
  /**
   * Video provider configuration successfully loaded.
   */
  SUCCESS = "SUCCESS",

  /**
   * Video provider configuration is being fetched.
   */
  IN_PROGRESS = "IN_PROGRESS",

  /**
   * Video provider configuration needs to be refreshed.
   */
  REFRESH = "REFRESH",

  /**
   * Video provider configuration fetch failed.
   */
  ERROR = "ERROR"
}
